import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetSectionHeaderPlaceholder} from "./entity-scores-widget.section-header.placeholder";
import {GameCardPlaceholderComponent} from "../../../../core/components/game-card/components/game-card.placeholder";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-placeholder.module.scss"

export class EntityScoresWidgetScoresSectionPlaceholderComponentProps extends BaseProps {
  gamesCount: Number;
}

export const EntityScoresWidgetSectionPlaceholder = ({gamesCount}: EntityScoresWidgetScoresSectionPlaceholderComponentProps) => {
  const games: Array<Object> = [];

  for (let i = 0; i < gamesCount; i++) {
    games.push({
      key: i
    });
  }

  return (
    <div className={classNames(styles.section_container)}>
      <div className={classNames(styles.section)}>
        <EntityScoresWidgetSectionHeaderPlaceholder/>
        {
          games.map((game) => <GameCardPlaceholderComponent key={game.key}/>)
        }
      </div>
    </div>
  )
}
